import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import CellLogo from '../../_assets/cell_logo_white.png';

class GenericNavbar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      sidebar: '',
      sidebarOpen: false
    }

    this.openSidebar = React.createRef();
    this.handleSidebarOpening = this.handleSidebarOpening.bind(this);
  }

  handleSidebarOpening() {
    let sidebar = '';

    if ( this.state.sidebar === '' ) {
      sidebar = document.querySelector('.sidebar');
    } else {
      sidebar = this.state.sidebar;
    }

    if ( this.state.sidebarOpen === true ) {
      sidebar.classList.remove('active');
      this.setState({sidebarOpen: false});
    } else {
      sidebar.classList.add('active');
      this.setState({sidebarOpen: true});
    }
  }

  render() {
    return (
      <nav className="navbar navbar-registering">
        <div className="container-fluid">
          <div className="row">
            <div className="col-2 hidden-md">
              <button className="open-sidebar" ref={this.openSidebar} onClick={this.handleSidebarOpening}>
                <i className="lnr lnr-menu"></i>
              </button> 
            </div>

            <div className="col">
              <Link to="/" className="logo">
                <img src={CellLogo} alt="Cell logo with blue as predominant color"/>
              </Link>
            </div>
          </div>
        </div>
      </nav>
    )
  }
}

export { GenericNavbar as GenericNavbarComponent };